// extracted by mini-css-extract-plugin
export var closeButton = "_b-1";
export var container = "_b-0";
export var fullModalImage = "_b-2";